import { render, staticRenderFns } from "./OptionSelector.vue?vue&type=template&id=8d7c7b5c&scoped=true&"
import script from "./OptionSelector.vue?vue&type=script&lang=js&"
export * from "./OptionSelector.vue?vue&type=script&lang=js&"
import style0 from "./OptionSelector.vue?vue&type=style&index=0&id=8d7c7b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7c7b5c",
  null
  
)

export default component.exports